import request from '@/router/axios';
// 同步区域
export const syncArea = (data) => {
  return request({
    url: '/api/blade-desk/dynamic/synDistrictData',
    method: 'get',
    params: data
  })
}
// 同步机构
export const ayncMechanism = (data) => {
  return request({
    url: '/api/blade-desk/dynamic/synOrgData',
    method: 'get',
    params: data
  })
}
// 同步用户
export const syncUser = (data) => {
  return request({
    url: '/api/blade-desk/dynamic/synUserData',
    method: 'get',
    params: data
  })
}
// 刷新缓存
export const flushDictCache = (data) => {
  return request({
    url: '/api/blade-system/api/processDeal/flushDictCache',
    method: 'get',
    params: data
  })
}
// 刷新权限
export const flushAuth = (data) => {
  return request({
    url: '/api/blade-system/api/processDeal/flushAuth',
    method: 'get',
    params: data
  })
}
// 执行sql文件
export const executeSql = (data) => {
  return request({
    url: '/api/blade-system/usual/api/executeSql',
    method: 'post',
    data: data
  })
}
// 上传sql文件
export const executeSqlFile = (data) => {
  return request({
    url: '/api/blade-system/usual/api/executeSql/file',
    method: 'post',
    data: data
  })
}
// 执行sql文件(数据源设置)
export const executeSqls = (data) => {
  return request({
    url: '/api/blade-develop/usual/api/executeSql',
    method: 'post',
    data: data
  })
}
// 缓存执行(数据源设置)
export const executeLocal = (data) => {
  return request({
    url: '/api/blade-develop/usual/api/executeRedisString',
    method: 'post',
    data: data
  })
}
// 上传sql文件(数据源设置)
export const executeSqlFiles = (data) => {
  return request({
    url: '/api/blade-develop/usual/api/executeSql/file',
    method: 'post',
    data: data
  })
}
